<!-- MenuWrapper.svelte -->
<script lang="ts">
    import { onDestroy } from 'svelte';
    import { MenuContextCustomActions } from '../MenuContextCustomActions';
    export let menu: MenuContextCustomActions | null = null;
    export let isDropdownOpen: boolean = true;
    export let onClick: () => {};

    function _onClick() {
        if (typeof onClick === 'function') onClick();
    }
</script>

{#if menu !== null}
    <MenuContextCustom {menu} bind:isDropdownOpen anchorVisible={false} />
{/if}
